import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useFormatter } from "./../../util/formatter";
import { Link } from "react-router-dom";

import $ from "jquery";
import JSZip from "jszip";
import moment from "moment-timezone";

import LoaderGraph from "../general/LoaderGraph";
import { Row, Col } from "react-bootstrap";
import { useSolarCalc } from "../../util/calculations";
import "./overview.css";
import { getGYUserCountry } from "../../util/roles";
import { useSite } from "../../util/sites";
import GYAxios from "../../util/GYAxios";

function OverviewSiteTables(props) {
	window.JSZip = JSZip;
	const [formatNumber] = useFormatter();
	const solarCalc = useSolarCalc();

	const [sites, setSites] = useState(null);
	const [ready, setReady] = useState(false);
	const [showInfo, setShowInfo] = useState(false);
	const [showLIPSites, setShowLIPSites] = useState(true);
	const [showTable, setShowTable] = useState(false);
	const [countryFilter, setCountryFilter] = useState("");
	const [countryList, setCountryList] = useState([]);
	const [countryFilterFocused, setCountryFilterFocused] = useState(false);
	const allSites = useSite().allSites_Select.map(s => s.options.map(o => o.value)).flat() || [];
	window.sitesFromUserSite = allSites; // for debugging
	
	
	const userType = props.user;
	const siteData = props.siteData;
	const opts = {
		lengthMenu: [
			[15, 30, -1],
			[15, 30, "All"],
		],
		order: [],
		columnDefs: [
			{ className: "table-center", targets: "_all" },
			{
				targets: [-1, -2],
				visible: false,
			},
		],
		dom: "lfrtiBp",
		buttons: [
			{
				extend: "excelHtml5",
				text: "Download datas",
				title: "Datas",
			},
		],
		responsive: true,
	};

	const redStyle = {
		color: "red",
		fontWeight: "bold",
	};

	/**
	 * Calculate CO2 and trees
	 * @param {Total solar} solarTotal
	 */
	const calculateCO2_TREES = (solarTotal) => {
		const co2 = Math.round(parseFloat(solarTotal) * 0.505);
		const trees = Math.round(co2 / 22.5);
		return {
			co2,
			trees,
		};
	};

	/**
	 * Format country search term for each site
	 * @param {Country of site} country
	 */

	/**
	 * Validate live data of sites and format accordingly
	 * @param {Live data of sites} liveData
	 */
	const validateLiveData = (liveData) => {
		const today = moment();
		const liveDate = moment(liveData.dateData);
		const diff = today.diff(liveDate, "minutes");
		const result = {
			solar_power:
				diff <= 22 && liveData.is_online == 1 ? liveData.solar_power : 0,
			irradiance:
				diff <= 22 && liveData.is_online == 1 ? liveData.irradiance : 0,
		};
		const tempSP = result.solar_power;
		const tempIrr = result.irradiance;

		if (formatNumber(tempSP) != formatNumber(tempIrr)) {
			if (formatNumber(tempSP) == 0) {
				result.redHighlight = "solar_power";
			} else {
				if (formatNumber(tempIrr) == 0) {
					result.redHighlight = "irradiance";
				} else {
					result.redHighlight = "";
				}
			}
		} else {
			result.redHighlight = "";
		}
		return result;
	};

	/**
	 * Format data
	 * @param {Site data} siteData
	 */
	const formatData = (siteData, showLIPSites) => {
		if(allSites.length === 0) {
			return;
		}
		if (siteData.length != 0) {
			const resLive = siteData[0];
			const resMonthly = siteData[1];
			const resYtd = siteData[2];
			const resToday = siteData[3];
			const resSiteAlarms = siteData[6];
			const resSitesAlarms = siteData[7];
			/* const resPrice = siteData[5].data.error == null ? siteData[5].data : []; */ // we no longer require price data to know that site is CO-ed or not
			const liveData = resLive.data;
			const monthlyData = resMonthly.data;
			const ytdData = resYtd.data;
			let todayData = resToday.data;

			/* const priceData = resPrice.map((price) => ({
				table_name: price.table_name,
				price_off: price.price_off,
				discount_off: price.OFF_discount,
				price_on: price.price_on,
				discount_on: price.ON_discount,
				FT_cost: price.FT_cost,
				FT_discount: price.FT_discount,
				currency: price.currency,
			})); */

			let resArr = [];

			/* if (priceData.length > 0) {
				todayData = todayData.map((row) => {
					if (moment().isBefore(moment(row.cod)) && row.client_id != 27)
						return { ...row, isTestSite: true };
					else return { ...row, isTestSite: false };
				});
			} */

			const clientType = ["client", "client_multi"];

			if (clientType.includes(userType.type)) {
				todayData = todayData.filter(
					(row) => row.operation_status == 2 || row.operation_status == 3,
				);

				/* todayData = todayData.map((row) => {
					const currency_unit = row?.country === "TH" ? "THB" : "VND";

					for (let i = 0; i < priceData.length; i++) {
						const price = priceData[i];
						let res = {};
						if (row.table_name === price.table_name) {
							res = { ...row, ...price };

						} else {
							const price_object = {
								table_name: row.table_name,
								price_off: 0,
								discount_off: 0,
								price_on: 0,
								discount_on: 0,
								FT_cost: 0,
								FT_discount: 0,
								currency: currency_unit,
							}
							res = { ...row, ...price_object };
						}

						return res;
					}
				}); */
			}

			todayData = todayData.map((row) => {
				const isTestSite =
					row.operation_status == 2 || row.operation_status == 3 ? false : true;
				return { ...row, isTestSite };
			});

			liveData.map((live) => {
				let finalObj = {};
				const table_name = live.table_name;
				const formattedLive = validateLiveData(live);
				const overallData = [
					{ data: "monthly", arr: monthlyData },
					{ data: "ytd", arr: ytdData },
					{ data: "today", arr: todayData },
				];
				overallData.map((dataObj) => {
					const tempArr = dataObj.arr;
					const tempData = dataObj.data;
					for (let i = 0; i < tempArr.length; i++) {
						const valObj = tempArr[i];
						const isValid = typeof valObj !== "undefined";

						if (isValid && valObj.table_name === table_name) {
							let objReq = {};
							switch (tempData) {
								case "monthly":
									objReq = {
										theoretical_PR: valObj.theoretical_PR,
										brut_PR: valObj.brut_PR,
										client_id: valObj.client_id,
										cod: valObj.cod,
									};
									break;

								case "ytd":
									objReq = {
										brut_PR_YTD: valObj.brut_PR,
										country: valObj.country,
									};
									break;

								case "today":
									/* const prod = {
										ON: valObj.solar_ON,
										OFF: valObj.solar_OFF,
										TOTAL: valObj.solar_total,
									};
									const price = {
										ON: valObj.price_on,
										OFF: valObj.price_off,
										FT: valObj.FT_cost,
									};
									const discount = {
										ON: valObj.discount_on,
										OFF: valObj.discount_off,
										FT: valObj.FT_discount,
									};
									const savingsObj = solarCalc.calculateSavings(
										prod,
										price,
										discount,
										valObj.currency
									); */

									/* const saving = savingsObj.savingsTotal; */
									const totalEnergy = valObj.solar_total + valObj.grid_total;
									const totalON = valObj.solar_ON + valObj.grid_ON;
									const totalOFF = valObj.solar_OFF + valObj.grid_OFF;

									objReq = {
										company: valObj.company,
										power: valObj.power,
										operation_status: valObj.operation_status,
										solar_power: valObj.solar_power,
										country: valObj.country,
										co2: calculateCO2_TREES(valObj.solar_total).co2,
										trees: calculateCO2_TREES(valObj.solar_total).trees,
										grid_OFF: valObj.grid_OFF,
										grid_ON: valObj.grid_ON,
										grid_total: valObj.grid_total,
										solar_OFF: valObj.solar_OFF,
										solar_ON: valObj.solar_ON,
										solar_total: valObj.solar_total,
										totalEnergy,
										totalON,
										totalOFF,
										/* saving, */
										isTestSite: valObj.isTestSite,
									};
									break;

								default:
									break;
							}

							finalObj = {
								...finalObj,
								...objReq,
							};
							break;
						}
					}
				});

				// add alarm data
				const siteAlarms = resSiteAlarms.data.data;
				const sitesAlarms = resSitesAlarms.data.data;
				const rawAlarms = sitesAlarms.filter(
					(item) => parseInt(item.site_id) === parseInt(live.site_id),
				);
				const alarms = rawAlarms.map((item) =>
					siteAlarms.find(
						(alarmDef) =>
							parseInt(alarmDef.alarm_id) === parseInt(item.alarm_id),
					),
				);
				alarms.sort((a, b) => a.alarm_slug.localeCompare(b.alarm_slug));
				alarms.sort((a, b) => b.trigger_alarm - a.trigger_alarm);

				const siteDataFromSelect = allSites.find(
					(site) => {
						return parseInt(site.site_id) === parseInt(live.site_id)
					}
				);

				let resObj = {
					site_id: live.site_id,
					company: siteDataFromSelect?.company || finalObj.company || "-",
					power: siteDataFromSelect?.power || finalObj.power || 0,
					status_name: live.status_name,
					status_color: live.status_color,
					overview_status: live.overview_status,
					is_grid_loss: live.is_grid_loss,
					site_name: siteDataFromSelect?.site_name || live.site_name || "-",
					solar_power: finalObj.solar_power != null ? finalObj.solar_power : 0,
					prYesterday: finalObj.brut_PR_YTD != null ? finalObj.brut_PR_YTD : 0,
					theoretical_PR:
						finalObj.theoretical_PR != null ? finalObj.theoretical_PR : 0,
					brut_PR: finalObj.brut_PR != null ? finalObj.brut_PR : 0,
					co2: finalObj.co2 != null ? finalObj.co2 : 0,
					trees: finalObj.trees != null ? finalObj.trees : 0,
					grid_OFF: finalObj.grid_OFF != null ? finalObj.grid_OFF : 0,
					grid_ON: finalObj.grid_ON != null ? finalObj.grid_ON : 0,
					grid_total: finalObj.grid_total != null ? finalObj.grid_total : 0,
					solar_OFF: finalObj.solar_OFF != null ? finalObj.solar_OFF : 0,
					solar_ON: finalObj.solar_ON != null ? finalObj.solar_ON : 0,
					solar_total: finalObj.solar_total != null ? finalObj.solar_total : 0,
					totalEnergy: finalObj.totalEnergy != null ? finalObj.totalEnergy : 0,
					totalON: finalObj.totalON != null ? finalObj.totalON : 0,
					totalOFF: finalObj.totalOFF != null ? finalObj.totalOFF : 0,
					/* saving: finalObj.saving != null ? finalObj.saving : 0, */
					solar_power: formatNumber(formattedLive.solar_power),
					irr: formatNumber(formattedLive.irradiance),
					redHighlight: formattedLive.redHighlight,
					isTestSite: finalObj.isTestSite,
					clientID: finalObj.client_id,
					country: finalObj.country,
					operation_status: finalObj.operation_status,
					cod: finalObj.cod,
					msa: finalObj.msa,
					alarms,
				};
				resArr.push(resObj);
			});

			if (!showLIPSites) {
				resArr = resArr.filter(
					(row) => row.operation_status !== 1 && row.clientID != null,
				);
			}

			if (userType?.roles && userType.roles.includes("_GY:External")) {
				const userCountry = getGYUserCountry(userType.roles);
				resArr = resArr.filter((row) => row.country === userCountry);
			}

			// sort site by number of alarms then by alarm name
			resArr.sort((a, b) => {
				const bAlarms = (b.alarms || []).filter(alarm => alarm.trigger_alarm).length;
				const aAlarms = (a.alarms || []).filter(alarm => alarm.trigger_alarm).length;
				return bAlarms - aAlarms;
			});
			resArr.sort((a, b) => {
				const aAlarm = a.alarms.filter(alarm => alarm.trigger_alarm).length > 0 ? a.alarms.filter(alarm => alarm.trigger_alarm)[0].alarm_slug : "z";
				const bAlarm = b.alarms.filter(alarm => alarm.trigger_alarm).length > 0 ? b.alarms.filter(alarm => alarm.trigger_alarm)[0].alarm_slug : "z";
				return aAlarm.localeCompare(bAlarm);
			});

			setSites(resArr);
			setReady(true);
		}
	};

	/**
	 * Build table header
	 * @param {Logged in user type} userType
	 */
	const buildTableHeader = (userType) => {
		switch (userType) {
			case "admin":
				return (
					<tr>
						<th>Client</th>
						<th>Site </th>

						<th>Plant capacity (kWp)</th>
						<th>Solar Power (kW)</th>
						<th>
							Solar Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>
							Grid Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>
							Total Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>Irradiance (W/m2)</th>
						<th>Actual PR Yesterday (%)</th>
						<th>Theoretical PR (Current Month) (%)</th>
						<th>Actual PR (Current Month) (%)</th>
						<th>Status</th>
						<th>Country</th>
						<th>Testing Site</th>
					</tr>
				);
			case "client":
			case "client_multi":
				return (
					<tr>
						<th>Site</th>
						<th>Plant capacity (kWp)</th>
						<th>Solar Power (kW)</th>
						<th>
							Solar Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>
							Grid Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>
							Total Energy (kWh) <p>(ON | OFF)</p>
						</th>
						<th>Irradiance (W/m2)</th>
						<th>Trees Planted (trees)</th>
						<th>CO2 Avoided (ton)</th>
						<th>Status</th>
						<th>Country</th>
						<th>Testing Site</th>
					</tr>
				);

			default:
				break;
		}
	};

	/**
	 * Populate table with rows of sites
	 * @param {Sites of table} sites
	 */
	const buildTableBody = (sites) => {
		const newArr = [];
		sites.forEach((site) => {
			if (userType.type !== "admin") {
				if (site.operation_status !== 1) {
					newArr.push(site);
				}
			} else {
				newArr.push(site);
			}
		});
		return newArr.map((site, key) => {
			let status, color;
			switch (site.operation_status) {
				case 1:
					status = " (LIP)";
					color = "#00757e";
					break;
				case 2:
					status = " (MSA)";
					color = "#ff8500";
					break;
				case 4:
					status = " (TEST)";
					color = "#8dc63f";
					break;
				default:
					status = "";
					color = "#666666";
					break;
			}

			const hasAlarm = site.alarms
				.map((alarm) => alarm.trigger_alarm)
				.some((elm) => !!elm);

			return (
				<tr key={site.site_id}>
					{userType.type === "admin" && <td>{site.company}</td>}
					<td>
						<Link
							to={`/solar/dashboard/${site.site_id}`}
							style={{ color: color }}
						>
							{site.site_name + status}
						</Link>
					</td>
					<td>{site.power}</td>
					<td style={site.redHighlight == "solar_power" ? redStyle : {}}>
						{site.solar_power}
					</td>
					<td>
						<b>
							<p>{formatNumber(site.solar_total)}</p>
						</b>
						<b>(</b>
						{formatNumber(site.solar_ON)} <b>|</b>{" "}
						{formatNumber(site.solar_OFF)}
						<b>)</b>
					</td>
					<td>
						<b>
							<p>{formatNumber(site.grid_total)}</p>
						</b>
						({formatNumber(site.grid_ON)} | {formatNumber(site.grid_OFF)})
					</td>
					<td>
						<b>
							<p>{formatNumber(site.totalEnergy)}</p>
						</b>
						({formatNumber(site.totalON)} | {formatNumber(site.totalOFF)})
					</td>
					<td style={site.redHighlight == "irradiance" ? redStyle : {}}>
						{site.irr}
					</td>
					{(userType.type === "client" || userType.type === "client_multi") && (
						<>
							<td>{site.trees}</td>
							<td>{site.co2}</td>

							<td
								style={{ color: hasAlarm ? "red" : "green" }}
							>
								<b>{hasAlarm ? "NOT OK" : "OK"}</b>
							</td>
						</>
					)}
					{userType.type === "admin" && (
						<>
							<td>{site.prYesterday}</td>
							<td>{site.theoretical_PR.toFixed(2)}</td>
							<td>{site.brut_PR}</td>
							<td>
								{/* Show OK if no critical alarms */}
								{!hasAlarm ? (
									<div>
										<b style={{ color: "green" }}>OK</b>
									</div>
								) : null}

								{site.alarms.map((alarm) => (
									<div id={`${site.site_id}:${alarm.alarm_id}`} key={`${site.site_id}:${alarm.alarm_id}`}>
										<b style={{ color: alarm.alarm_color }}>
											{alarm.alarm_slug}
										</b>
									</div>
								))}
							</td>
						</>
					)}
					<td>{site.country}</td>
					<td>{site.isTestSite ? "TEST" : ""}</td>
				</tr>
			);
		});
	};

	/**
	 * Handle checkbox change of LIP sites
	 * @param {On change event} evt
	 */
	const handleLIPChange = (evt) => {
		const isChecked = evt.target.checked;
		setReady(false);
		setShowLIPSites(isChecked);
	};

	useEffect(() => {
		if (!userType) {
			return;
		}
		GYAxios.get("/select/countries").then((res) => {
			const countryOptions = res.data; // The response also includes 'ALL' option and filter out 'KH' option
			setCountryList(countryOptions);
		});
	}, [userType]);

	useEffect(() => {
		formatData(siteData, showLIPSites);
	}, [showLIPSites, countryFilter, allSites.length]);

	useEffect(() => {
		// Datatables is imported in pages/_app.js
		const isInitialized = $.fn.DataTable.isDataTable("#siteTable");

		if(!ready) {
			setShowTable(false);
		}
		const countryColIndex = userType.type === "admin" ? 12 : 10;
		if (!isInitialized && ready) {
			const dt = $("#siteTable").DataTable(opts);
			if (countryFilter) {
				dt.column(countryColIndex).search(`^${countryFilter}$`, true, false).draw();
			}
			setShowTable(true);
		}
		if (isInitialized && ready) {
			$("#siteTable").DataTable().column(countryColIndex).search(countryFilter ? `^${countryFilter}$` : "", true, false).draw();
			setShowTable(true);
		}

		const timer = setInterval(() => {
			console.log("Add a reload feature..");
		}, 600000);

		return () => {
			const exists = $.fn.DataTable.isDataTable("#siteTable");
			if (exists) {
				$("#siteTable").DataTable().destroy();
			}
			setShowTable(false);
			clearInterval(timer);
		};
	}, [ready, countryFilter, userType.type]);

	return (
		sites && (
			<>
				<div
					className="perf-table panel panel-default"
					style={{ marginTop: "50px" }}
				>
					<div className="panel-heading" style={{ marginBottom: "30px" }}>
						<Row>
							<Col md={6} style={{ display: "flex", alignItems: "center" }}>
								<h2 className="panel-title" id="overview-title">
									Sites Overview for today
									{userType.type === "admin" && (
										<span
											className="glyphicon glyphicon-info-sign info-icon"
											onMouseEnter={() => setShowInfo(true)}
											onMouseLeave={() => setShowInfo(false)}
										></span>
									)}
								</h2>
								{showInfo && (
									<div className="info-card">
										<h5>Additional search terms: </h5>
										<ul>
											<li>
												Country: eg. <b>THAI / VIET</b>
											</li>
											<li>
												Sites in test period: eg. <b>TEST</b>
											</li>
											<li>
												Multiple columns: eg. <b>THAI REG</b>
												<p>** Search Terms separated by space (" ")</p>
											</li>
										</ul>
									</div>
								)}
							</Col>
							<Col
								md={6}
								style={{
									textAlign: "right",
									display: "flex",
									gap: "20px",
									alignItems: "center",
									justifyContent: "flex-end",
								}}
							>
								{userType.roles && userType.roles.includes("_GY:Base") && (
									<div>
										<label
											htmlFor="countryFilter"
											style={{
												marginRight: "16px",
												fontSize: "16px",
											}}
										>
											Country:
										</label>
										<select
											id="countryFilter"
											className="form-control"
											style={{
												display: "inline-block",
												width: "200px",
												color: "black",
												backgroundColor: "white",
												padding: "0.5em",
											}}
											value={countryFilter}
											onChange={(e) => setCountryFilter(e.target.value)}
											onFocus={() => setCountryFilterFocused(true)}
											onBlur={() => setCountryFilterFocused(false)}
										>
											<option value="" style={{ color: "black" }}>
												All Countries
											</option>
											{countryList
												.filter((c) => c.value != "ALL")
												.map((c) => (
													<option
														key={c.value}
														value={c.value}
														style={{ color: "black" }}
													>
														{c.label}
													</option>
												))}
										</select>
									</div>
								)}
								{userType.type === "admin" && (
									<div>
										<label className="LIP-label" htmlFor="showLIP">
											License in progress sites
										</label>
										<input
											type="checkbox"
											id="showLIP"
											name="showLIP"
											onChange={handleLIPChange}
											checked={showLIPSites}
										/>
									</div>
								)}
							</Col>
						</Row>
					</div>
					{!showTable && (
						<LoaderGraph
							style={{
								height: "100vh",
								width: "100vw",
								zIndex: "100",
							}}
						/>
					)}
					<div id="tableCont" className="panel-body">
						<table
							id="siteTable"
							className="table table-striped table-bordered"
							style={{ width: "100%" }}
						>
							<thead>{buildTableHeader(userType.type)}</thead>
							<tbody>{buildTableBody(sites)}</tbody>
						</table>
					</div>
				</div>
			</>
		)
	);
}

export default OverviewSiteTables;
